import { useStepperContext } from "../../stepper.context";
import type { StepperStepProps, StepperStepViewProps } from "./types-step";

/** ViewModel do Stepper.Step: `aria-current`, botão desabilitado sem `onSelect` e o check do passo concluído; sem JSX. */
export function useStepperStep({
  state,
  number,
  title,
  onSelect,
  ariaLabel,
  tag,
  description,
  footer,
  testId,
  classNames,
  className,
  children,
  ...rest
}: StepperStepProps): StepperStepViewProps {
  useStepperContext();

  return {
    state,
    number,
    title,
    tag,
    description,
    footer,
    panel: children,
    testId,
    className,
    classNames,
    ariaLabel,
    ariaCurrent: state === "active" ? "step" : undefined,
    disabled: !onSelect,
    showCheck: state === "done",
    onSelect,
    rest,
  };
}
